import { RoleMe } from '@/types/roles'
import { UserProfile } from '@/types/user'
import { create } from 'zustand'
interface UserStore {
  isLogin: boolean
  sessionTimeout: boolean
  profile: UserProfile | null
  rolesMe: RoleMe[]
  setIsLogin: (val: boolean) => void
  setSessionTimeout: (val: boolean) => void
  setProfile: (profile: UserProfile | null) => void
  setRolesMe: (role: RoleMe[]) => void
}

const initialValue = {
  isLogin: false,
  sessionTimeout: false,
  profile: null,
  rolesMe: [],
}
export const useUserStore = create<UserStore>((set) => ({
  ...initialValue,
  setIsLogin: (val) => set(() => ({ isLogin: val })),
  setSessionTimeout: (val) => set(() => ({ sessionTimeout: val })),
  setProfile: (val) => set(() => ({ profile: val })),
  setRolesMe: (val) => set(() => ({ rolesMe: val })),
}))
